"use client";

import { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ProductGallerySlider = ({ images }) => {
  // State to track which images have loaded
  const [loadedImages, setLoadedImages] = useState({});

  const settings = {
    dots: false,
    infinite: images.length > 1, // Disable infinite mode if there's only one image
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
  };

  // Handle image load
  const handleImageLoad = (imageId) => {
    setLoadedImages((prev) => ({
      ...prev,
      [imageId]: true,
    }));
  };

  return (
    <Slider {...settings} className="m-b5 primary btn-style-2" id="sync1">
      {images.map((item, id) => (
        <div key={id} className="item">
          <div className="mfp-gallery">
            <div className="dlab-box">
              <div
                className="dlab-thum-bx dlab-img-overlay1"
                style={{ position: "relative" }}
              >
                {/* Loading spinner overlay */}
                {!loadedImages[id] && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#f5f5f5",
                      zIndex: 1,
                    }}
                  >
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                )}
                <img
                  src={
                    process.env.REACT_APP_API_URL + item || "/placeholder.svg"
                  }
                  alt=""
                  style={{
                    opacity: loadedImages[id] ? 1 : 0,
                    transition: "opacity 0.3s ease-in-out",
                  }}
                  onLoad={() => handleImageLoad(id)}
                />
                <div className="overlay-bx">
                  <div className="overlay-icon">
                    <span
                      data-exthumbimage={item}
                      data-src={item}
                      className="check-km"
                      title="Image 1 Title will come here"
                    >
                      <i className="ti-fullscreen"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default ProductGallerySlider;
